import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Icon from '../../../../../components/icons'
import Button from '../../../../../elements/button'
import CommonInputText from '../../../../../components/commonInputText'

import { Controller, useForm } from 'react-hook-form'
import SaveFeaturesSuccessModal from './saveFeaturesSuccess.modal'
import { useExperimentApi } from '../../../../../store/api/hooks/experimentApiHook'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import { useFpLoader } from '../../../../../store/api/hooks/fpLoaderHook'
import Dropdown from '../../../../../elements/Form/dropdown'
import { trackEvent } from '../../../../../_common/functions'

interface SaveFeaturesModalProps {
    _ref: any
    query: any
    onSaved?: (q: string) => void
}

const SaveFeaturesModal: React.FC<SaveFeaturesModalProps> = ({ _ref, query, onSaved }) => {
    const { t } = useTranslation()
    const experimentApi = useExperimentApi()
    const { showLoader, hideLoader } = useFpLoader()
    const params = useParams()
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm()

    const successModalRef: any = useRef()

    console.log('SaveFeaturesModal Rendered', errors)

    const saveFeatures = (data: any) => {
        trackEvent('wizard_save_features_clicked', {})
        showLoader()
        const paramspost: any = {
            literal: params.experiment,
            script: query,
            table_name: data.feature_name,
            table_alias: data.purpose,
            refresh_frequency: data?.refresh_frequency?.value,
            purpose: data.purpose,
        }

        experimentApi.createUserDesign(
            paramspost,
            (data: any) => {
                trackEvent('wizard_save_features_success', {})
                hideLoader()
                onSaved?.(query)
                _ref.current?.close()
                successModalRef.current?.showModal()
            },
            (error: any) => {
                hideLoader()
                toast.error(error?.message)
            },
        )
    }

    return (
        <>
            <dialog ref={_ref} className="modal" data-testid="save-features-modal">
                <div className="modal-box" data-testid="modal-box">
                    <form onSubmit={handleSubmit(saveFeatures)} id="save-feature-data">
                        <p className="font-bold text-center text-[1.333rem] leading-8" data-testid="modal-title">
                            {t('Save This Query As a reusable Table')}
                        </p>

                        <div className="my-8">
                            <Controller
                                data-testid="feature-name-input"
                                name="feature_name"
                                control={control}
                                rules={{
                                    required: t('Please Enter Feature Name'),
                                    minLength: {
                                        value: 2,
                                        message: t('Feature Name should be atleast 2 character'),
                                    },
                                    maxLength: {
                                        value: 30,
                                        message: t('Maximum 30 character allowed'),
                                    },
                                }}
                                render={({ field }) => <CommonInputText {...field} label={t('Feature Name')} required placeholder={t('Enter Feature Name')} error={(errors?.feature_name?.message as string) || ''} data-testid="feature-name-input" />}
                            />
                            <br />
                            <Controller
                                data-testid="refresh-frequency-dropdown"
                                name="refresh_frequency"
                                control={control}
                                rules={{
                                    required: t('Please select Refresh frequency'),
                                }}
                                render={({ field: { onChange, value } }) => (
                                    <Dropdown
                                        data-testid="refresh-frequency-dropdown"
                                        label={t('Select Refresh Frequency')}
                                        required={true}
                                        placeholder={t('Select')}
                                        value={value}
                                        onChange={onChange}
                                        options={[
                                            { label: t('Daily'), value: 100 },
                                            { label: t('Weekly'), value: 101 },
                                            { label: t('Monthly'), value: 102 },
                                            { label: t('Quarterly'), value: 103 },
                                            { label: t('Half-Yearly'), value: 104 },
                                            { label: t('Yearly'), value: 105 },
                                        ]}
                                        error={(errors?.refresh_frequency?.message as string) || ''}
                                    />
                                )}
                            />
                            <br />
                            <Controller
                                name="purpose"
                                control={control}
                                rules={{
                                    required: false,
                                    validate: {
                                        max50: (value) => {
                                            if (!value) return true // not required → empty is allowed
                                            return value.length <= 50 || t('Maximum 50 characters allowed')
                                        },
                                    },
                                }}
                                render={({ field: { onChange, onBlur, value, ref, name } }) => (
                                    <CommonInputText
                                        label={t('Purpose')}
                                        className=""
                                        name={name}
                                        value={value}
                                        onChange={onChange}
                                        placeholder={t('Say about the Purpose')}
                                        data-testid="purpose-input"
                                        error={(errors?.purpose?.message as string) || ''}
                                    />
                                )}
                            />
                        </div>

                        <div className="flex justify-center">
                            <Button type="submit" theme="secondary" size="sm" className="text-white" data-testid="save-button">
                                <Icon name="save" />
                                {t('Save Features')}
                            </Button>
                        </div>
                    </form>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button type="button">{t('close')}</button>
                </form>
            </dialog>
            <SaveFeaturesSuccessModal _ref={successModalRef} dataTestId="save-success-modal" />
        </>
    )
}

export default SaveFeaturesModal
